const $$splitComponentImporter = () => import('/Users/Javvad_1/Desktop/Petso_Dev/monorepo/petso-pro/src/routes/dashboard/team.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/team')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface TeamMember {
  id: string;
  businessId: string;
  userClerkId: string | null;
  roleId: string;
  roleName: string;
  roleType: string;
  locationIds: string[];
  status: string;
  inviteEmail: string;
  invitedBy: string;
  displayName: string | null;
  title: string | null;
  phone: string | null;
  specializations: string[] | null;
  joinedAt: string | null;
  createdAt: string;
  user: {
    fullName: string;
    imageUrl: string;
    email: string;
  } | null;
}
interface Role {
  id: string;
  name: string;
  type: string;
}

// ─── Branch selector: grouped by business with tristate parent + master toggle ──

interface BranchSelectorLocation {
  id: string;
  name: string;
  businessId: string;
  businessName: string | null;
}